import axios from "axios";


const teste = 'https://api.grupohk.com.br:5006'

export default axios.create({
  baseURL: process.env.REACT_APP_URL_API_MESSAGER,
})